
import { ExerciseItem } from "@/components/routines/exercise/ExerciseItem";
import { EditExerciseDialog } from "@/components/routines/exercise/EditExerciseDialog";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { useGranularFieldUpdater } from "../../hooks/useGranularFieldUpdater";

interface ExerciseListSectionProps {
  exercises: any[];
  routineId: string;
  onExerciseChange: () => void;
  showControls?: boolean;
  isPersonalPlan?: boolean;
}

export const ExerciseListSection = ({ 
  exercises, 
  routineId, 
  onExerciseChange,
  showControls = true,
  isPersonalPlan = false
}: ExerciseListSectionProps) => {
  const [selectedExercise, setSelectedExercise] = useState<any>(null);
  const [exerciseName, setExerciseName] = useState("");
  const { updateExerciseField } = useGranularFieldUpdater();

  const handleExerciseEdit = (exercise: any) => {
    setSelectedExercise(exercise);
    setExerciseName(exercise.name);
  };

  const handleExerciseDelete = async (exerciseId: string) => {
    try {
      const { error } = await supabase
        .from("exercises")
        .delete()
        .eq("id", exerciseId);

      if (error) throw error;

      toast({
        title: "Ejercicio eliminado",
        description: "El ejercicio ha sido eliminado de la rutina",
      });

      // Solo trigger refetch completo para eliminaciones
      onExerciseChange();
    } catch (error) {
      console.error("Error deleting exercise:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo eliminar el ejercicio",
      });
    }
  };

  const handleExerciseUpdate = async (exerciseId: string, field: string, value: any) => {
    try {
      const { error } = await supabase
        .from("exercises")
        .update({ [field]: value })
        .eq("id", exerciseId);

      if (error) throw error;

      // 🎯 ACTUALIZACIÓN GRANULAR - Solo actualizar el campo específico
      updateExerciseField(routineId, exerciseId, field, value);
      
      console.log(`✅ Granular update: ${exerciseId}.${field} = ${value}`);

    } catch (error) {
      console.error("Error updating exercise:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo actualizar el ejercicio",
      });
    }
  };

  const handleSaveExercise = async () => {
    if (selectedExercise) {
      await handleExerciseUpdate(selectedExercise.id, "name", exerciseName);
      setSelectedExercise(null);
    }
  };

  return (
    <div className="space-y-4">
      {exercises.map((exercise) => (
        <ExerciseItem
          key={exercise.id}
          exercise={exercise}
          onEdit={handleExerciseEdit}
          onDelete={handleExerciseDelete}
          onUpdate={handleExerciseUpdate}
          showControls={showControls}
        />
      ))}

      <EditExerciseDialog
        isOpen={!!selectedExercise}
        onOpenChange={(open) => !open && setSelectedExercise(null)}
        exerciseName={exerciseName}
        onExerciseNameChange={setExerciseName}
        onSave={handleSaveExercise}
      />
    </div>
  );
};
